import * as React from 'react';
import { ProgressiveHydration, registerComponent } from '@avensia/excite';
import { Document } from '@avensia/excite-contentful';
import { Block, contentWidthDecorator, desktopEdgeMarginDecorator } from 'webapp/components/page-layout';
import { styled } from '@glitz/react';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';
import { useLayout } from 'webapp/shared/use-layout';

export default registerComponent<NordicNest.Api.EditorialBlock>(props => {
  const { hasLayoutBlockParent } = useLayout();
  return (
    <ProgressiveHydration>
      <EditorialBlock {...props} hasLayoutBlockParent={hasLayoutBlockParent} />
    </ProgressiveHydration>
  );
});

function EditorialBlock(props: NordicNest.Api.EditorialBlock & { hasLayoutBlockParent: boolean }) {
  return (
    <Base
      id={props.id}
      css={styled(
        contentWidthDecorator(props.contentWidth),
        props.marginTop && marginDecorator,
        props.contentWidth === 'normal' && !props.hasLayoutBlockParent && desktopEdgeMarginDecorator,
      )}
    >
      <Document elements={props.content?.elements} />
    </Base>
  );
}

const Base = styled(
  Block,
  createMaxSmallViewportDecorator({
    padding: { x: t => t.spacing.m },
  }),
  {
    marginBottom: t => t.spacing.l,
  },
);

const marginDecorator = styled(createMaxSmallViewportDecorator({ marginTop: t => t.spacing.m }), {
  marginTop: t => t.spacing.xl,
});
